
// Everything we define here is accessible in components
// via this.$config.PROPRETYNAME

export default {
   dpr: window.devicePixelRatio,
   defaultImageURL: "/static_assets/placeholder.png?updatedAt=1624972325445"
   // showJSON: process.env.VUE_APP_NODE_ENV !== "production" ? true : false
}
